import { compareStringsAlphabetically } from "utils/utils";
import useActivityFiltersMetadata, {
  type ActivityFilterMetadata
} from "components/feature-entity-linking-page/hooks/use-activity-filters";
import { useMemo } from "react";
import type { FilterOptions } from "./schedule-filter-bar";

export type CsvMetadataEntry = ActivityFilterMetadata;

export function useCsvFilterMetadata(enabled = true, xerS3Key?: string) {
  const {
    metadataMap,
    loading,
    hasCompletedRecommenderJob,
    isRecommenderJobPending,
    hasRecommenderJobError
  } = useActivityFiltersMetadata(enabled, xerS3Key);

  const filterOptions = useMemo((): FilterOptions => {
    const phases = new Set<string>();
    const activityTypes = new Set<string>();
    const csiDivisions = new Set<string>();
    const locations = new Set<string>();

    for (const entry of metadataMap.values()) {
      if (entry.phase && entry.phase !== "Root") phases.add(entry.phase);
      if (entry.activity_type && entry.activity_type !== "Summary")
        activityTypes.add(entry.activity_type);
      if (entry.csi_division) csiDivisions.add(entry.csi_division);
      if (entry.location_tags) locations.add(entry.location_tags);
    }

    return {
      phases: [...phases].sort(compareStringsAlphabetically),
      activityTypes: [...activityTypes].sort(compareStringsAlphabetically),
      csiDivisions: [...csiDivisions].sort(compareStringsAlphabetically),
      locations: [...locations].sort(compareStringsAlphabetically)
    };
  }, [metadataMap]);

  return {
    metadataMap,
    filterOptions,
    loading,
    hasCompletedRecommenderJob,
    isRecommenderJobPending,
    hasRecommenderJobError
  };
}
